import { memo, useCallback } from 'react';
import { useAsync } from 'react-use';
import cn from 'classnames';
import { getWithUrl } from 'src/utils/http';
import { Container, Element, Icon, RouterLink } from 'src/components';

import { API_URL } from '@zmedia/bm-soccer-ui/constants/env';
import { IMatch } from '@zmedia/bm-soccer-ui/interface';
import MatchItem from './MatchItem';
import { twMerge } from 'tailwind-merge';
import { IContent } from 'src/interface';

interface ISoccerEvent {
    items: IMatch[];
    name: string;
    url: string;
}

const SOCCER_API = API_URL + '/app/match/get/widget-content-detail';

const EventSoccer = ({ content }: { content: IContent }) => {
    const matchState = useAsync(() =>
        getWithUrl(
            SOCCER_API,
            {
                tournamentId: content.tournamentId,
            },
            []
        )
    );

    const data: ISoccerEvent = matchState.value?.data || {};
    const { items = [], name, url } = data;

    const renderItem = useCallback(() => {
        return items.map((item: IMatch) => (
            <RouterLink
                key={item.id}
                to={item.url}
                className={twMerge(
                    'w-[46%]',
                    'shrink-0',
                    'mx-[4px]',
                    'rounded-[12px]',
                    'border border-solid border-[#ececec]',
                    cn({
                        'w-1/2 shrink': items.length <= 2,
                    })
                )}
            >
                <MatchItem {...item} />
            </RouterLink>
        ));
    }, [items]);

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Element
                className={cn(
                    'event-soccer',
                    'max-md:mx-[-16px]',
                    'xs:max-md:mx-[-10vw]',
                    'mt-[16px]'
                )}
            >
                <Element
                    className={cn(
                        'bg-[#F4F5F9]',
                        'px-[16px] py-[11px]',
                        'mb-[16px]',
                        'flex items-center justify-between'
                    )}
                >
                    <Element
                        className={cn('text-[#000] text-[1.6rem] font-semibold')}
                    >
                        {name}
                    </Element>
                    <RouterLink
                        to={url}
                        className={cn(
                            'border border-solid border-[#b3b3b3]',
                            'rounded-full',
                            'px-[12px] py-[2px]',
                            'flex items-center'
                        )}
                    >
                        <Element className="text-[#595959] italic">Xem thêm</Element>
                        <Icon className='text-[1rem] ml-[5px] text-[#1e1e1e]' icon="chevron-right" />
                    </RouterLink>
                </Element>

                <Container>
                    <Element
                        className={cn(
                            'max-md:mx-[-16px]',
                            'max-md:px-[12px]',
                            'xs:max-md:mx-[-10vw]',
                            'xs:max-md:px-[calc(10vw-4px)]',
                            'md:mx-[-20px]',
                            'flex',
                            'overflow-auto [&::-webkit-scrollbar]:hidden'
                        )}
                    >
                        {renderItem()}
                    </Element>
                </Container>
            </Element>
        </>
    );
};
export default memo(EventSoccer);
